import { Box, Typography } from '@material-ui/core';

import { ControlledSelect } from '../../../../components/controlled-inputs';
import { Shift, TimeAndAttendanceLocation } from '../../../../types';

export const LocationAndShiftControlBlock = ({
  locations = [],
  shifts = [],
}: {
  locations: TimeAndAttendanceLocation[];
  shifts?: Shift[];
}) => {
  return (
    <Box display="flex" flexWrap="wrap" alignItems="center" gridGap={8}>
      <Typography variant="subtitle2">Select the rules for</Typography>
      <Box width="200px">
        <ControlledSelect name="location" items={locations || []} multiple={false} />
      </Box>
      <Typography variant="subtitle2">Location's</Typography>
      <Box width="200px">
        <ControlledSelect name="shift" items={shifts || []} multiple={false} />
      </Box>
      <Typography variant="subtitle2">Shift:</Typography>
    </Box>
  );
};
